import { Component, Input } from '@angular/core';
import { FileInfo } from '@app/core/services/file.service';
import { LayoutService } from '@app/core/services/layout.service';
import { ModalService } from '@app/core/services/modal.service';
import { StateService } from '@app/core/services/state.service';
import { DocumentItem } from '@app/services/document.service';

export type PictureCardItem = DocumentItem & Partial<FileInfo>;

@Component({
    selector: 'tt-picture-card',
    templateUrl: './picture-card.component.html',
    styleUrls: ['./picture-card.component.css'],
    standalone: false,
})
export class PictureCardComponent {
    @Input()
    public set picture(value: PictureCardItem) {
        this._picture = value;
        this.imageMissing = !value?.url;
    }
    public get picture(): PictureCardItem {
        return this._picture;
    }
    private _picture!: PictureCardItem;

    @Input()
    public view: 'grid' | 'list' = 'grid';

    @Input()
    public argtype = '';

    @Input()
    public argvalue = '';

    public imageMissing = false;

    constructor(
        private layout: LayoutService,
        private modal: ModalService,
        private state: StateService,
    ) {}

    public onImageError(): void {
        const url = this.picture.url;
        queueMicrotask(() => {
            if (this.picture.url === url) this.imageMissing = true;
        });
    }

    public open(): void {
        const params = `${this.argtype}/${this.argvalue}/${this.picture.item_id}`;

        if (this.layout.getMediaQueries().tablet.matches) {
            void this.modal.openStateDialog({ state: 'docarc', params });
            return;
        }

        this.state.go('docarc', {
            argtype: this.argtype,
            argvalue: this.argvalue,
            docarc_keyno: this.picture.item_id,
        });
    }
}
